import cx from 'classnames';
import * as React from 'react';
import { useId } from '../helper/hooks';
import { Container } from '../Layout/Container';

export type AttentionBannerProps = {
  /**
   * show the close button for user to hide this attention banner
   */
  dismissible?: boolean;
  children: React.ReactNode;
} & JSX.IntrinsicElements['div'];

/**
 *
 * @see https://styleguide.topdanmark.dk/components/detail/attention-banner.html
 */
export const AttentionBanner = ({ dismissible, className, children, ...props }: AttentionBannerProps) => {
  const [hidden, setHidden] = React.useState(false);
  const confirmedId = useId(props.id);

  return hidden ? null : (
    <div className={cx('AttentionBanner', className)} {...props}>
      <Container>
        <span className="AttentionBanner-ico">!</span>
        {children}
        {dismissible && (
          <a
            onClick={(ev) => {
              ev.preventDefault();
              setHidden(true);
            }}
            href={`#${confirmedId}-close`}
            id={`${confirmedId}-close`}
            className="AttentionBanner-close"
            role="button"
          >
            <span className="ico-delete" aria-hidden>
              x
            </span>
            <span className="sr-only">Dismiss</span>
          </a>
        )}
      </Container>
    </div>
  );
};
